import { Copy, Save, Trash2 } from 'lucide-react'
import React, { useCallback } from 'react'
import './selection-overlay.css'

interface SelectionOverlayProps {
	selectedCount: number
	onSaveAsConcept: () => void
	onDelete: () => void
	onDuplicate: () => void
	position?: { x: number; y: number }
}

export function SelectionOverlay({
								 selectedCount,
								 onSaveAsConcept,
								 onDelete,
								 onDuplicate,
								 position = { x: 20, y: 20 },
							 }: SelectionOverlayProps) {
	const handleMouseDown = useCallback((e: React.MouseEvent) => {
		// CRITICAL: Stop mousedown from bubbling to parent handlers
		// Following toolbar-event-propagation pattern from docs/components/toolbar-event-propagation.md
		e.stopPropagation()
	}, [])

	const handleClick = useCallback((e: React.MouseEvent) => {
		// Stop clicks from bubbling to parent handlers
		e.stopPropagation()
	}, [])

	if (selectedCount < 2) {
		return null
	}

	return (
		<div
			className="selection-overlay"
			style={{ top: position.y, left: position.x }}
			onMouseDown={handleMouseDown}
			onClick={handleClick}
		>
			<div className="selection-overlay-count">
				{selectedCount} selected
			</div>

			<button
				onClick={onSaveAsConcept}
				className="selection-overlay-button-save"
				title="Save selection as concept"
			>
				<Save className="selection-overlay-icon" />
				Save as Concept
			</button>

			<button
				onClick={onDuplicate}
				className="selection-overlay-button-icon"
				title="Duplicate selection"
			>
				<Copy className="selection-overlay-icon" />
			</button>

			<button
				onClick={onDelete}
				onMouseDown={handleMouseDown}
				className="selection-overlay-button-delete"
				title="Delete selection"
			>
				<Trash2 className="selection-overlay-icon" />
			</button>
		</div>
	)
}
